<script setup lang="ts">
import { computed, inject, type ComputedRef } from 'vue';
import { useGlobalStore } from 'src/stores/global';
import { useUserAvatar } from 'src/modules/Avatar/composables/useUserAvatar';
import ManageAvatarView from '../../views/ManageAvatarView/ManageAvatarView.vue';

const globalStore = useGlobalStore();
globalStore.showBreadcrumbs = false;

const currentUser = inject('currentUser') as ComputedRef<
  { id?: number | null } | undefined
>;
const currentUserId = inject('currentUserId') as ComputedRef<number | null>;
const userId = computed(
  () => currentUserId?.value ?? currentUser?.value?.id ?? null,
);

// Listen for save requests and persist to backend
const { isSaving } = useUserAvatar(userId.value);
</script>

<template>
  <q-page class="avatar-editor-page">
    <manage-avatar-view :is-saving-profile="isSaving" />
  </q-page>
</template>
